<template>
  <div class="header">
    <a-dropdown class="header-item">
      <a class="ant-dropdown-link" href="#">
        <a-avatar v-if="userInfo.photoName"  :src="userInfo.photoName" />
        <a-avatar v-else style="backgroundColor:#1890FF" icon="user" />
        <span style="vertical-align: middle;margin-left:10px">
          {{ userInfo.userName }}
        </span>
      </a>
      <a-menu slot="overlay">
        <a-menu-item>
          <router-link to="/user-mana/user-center">
            <a-icon type="setting" style="margin-right: 10px" />用户中心
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <a href="javascript:;" @click="handlerSignOut">
            <a-icon type="logout" style="margin-right: 10px" />退出登录
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {sessionLogout} from "@/apis/login";

export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.userStore.userInfo || {}
    })
  },
  beforeRouteLeave(to, from) {
    console.log('--header beforeRouteLeave--')
  },
  methods: {
    async handlerSignOut() {
      try {
        await sessionLogout()
        this.$router.push({ path: '/login' })
      } catch (error) {}
    }
  }
}
</script>

<style scoped>
.header {
  float: right;
  padding-right: 16px;
}
.header-item {
  display: inline-block;
  height: 100%;
  padding: 0 12px;
  cursor: pointer;
  transition: all 0.3s;
  color: rgba(0, 0, 0, 0.65);
}
.header-item:hover {
  background-color: rgba(0, 0, 0, 0.025);
}

.warnning-bell-warp {
  height: 100%;
  padding: 0 12px;
  display: inline-block;
  margin-right: 14px;
  vertical-align: middle;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.65);
}

.default-avatar {
  /* width: 32px; */
  height: 32px;
  /* border-radius: 50%; */
}
</style>
